import React from 'react';
import { Title, Group, Text, Loader } from '@mantine/core';
import { PageContainer } from '../../components/ui/PageContainer';
import { LoadFailed } from '../../components/ui/LoadFailed';
import { useTranslation } from 'react-i18next';
import { useReviewRequestsManager } from '../../hooks/useReviewRequestsManager';
import { CompetencyDrawer } from '../../components/competency/CompetencyDrawer';
import { ReviewRequestsTable } from '../../components/review/ReviewRequestsTable';
import { CompetencyReviewDetailsModal } from '../../components/competency/CompetencyReviewDetailsModal';

export const ReviewRequests: React.FC = () => {
  const { t } = useTranslation();
  const {
    myRequests,
    requestsToReview,
    isLoading,
    error,
    selectedRequest,
    isModalOpen,
    drawer,
    getStatusConfig,
    handleStatusUpdate,
    handleReject,
    handleRemind,
    handleResubmit,
    handleDelete,
    handleView,
    handleCloseModal,
    handleOpenDrawer,
    handleCloseDrawer,
  } = useReviewRequestsManager();

  if (isLoading) {
    return (
      <PageContainer>
        <Group justify="center" py="xl">
          <Loader size="sm" />
        </Group>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer>
        <LoadFailed message={t('errors.loadFailed')} hasRetry />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Group gap="md" align="center" mb={{ base: 'md', sm: 'xl' }}>
        <Title order={2}>{t('reviewRequests.title')}</Title>
      </Group>

      {/* Блок "У меня на ревью" */}
      {requestsToReview.length > 0 && (
        <ReviewRequestsTable
          title={t('reviewRequests.requestsToReview')}
          requests={requestsToReview}
          showApplicant={true}
          showReviewer={false}
          onView={handleView}
          onApprove={(requestId) => handleStatusUpdate(requestId, 'approved')}
          onReject={handleReject}
          onDelete={handleDelete}
          onOpenCompetencyDrawer={handleOpenDrawer}
        />
      )}

      {/* Блок "Мои заявки на ревью" */}
      {myRequests.length > 0 && (
        <ReviewRequestsTable
          title={t('reviewRequests.myRequests')}
          requests={myRequests}
          showApplicant={false}
          showReviewer={true}
          onView={handleView}
          onRemind={handleRemind}
          onResubmit={handleResubmit}
          onDelete={handleDelete}
          onOpenCompetencyDrawer={handleOpenDrawer}
        />
      )}

      {/* Сообщение, если нет заявок */}
      {requestsToReview.length === 0 && myRequests.length === 0 && (
        <Text ta="center" c="dimmed" py="xl">
          {t('reviewRequests.noRequests')}
        </Text>
      )}

      {/* Модальное окно для просмотра деталей */}
      <CompetencyReviewDetailsModal
        opened={isModalOpen}
        onClose={handleCloseModal}
        selectedRequest={selectedRequest}
        getStatusConfig={getStatusConfig}
      />

      {/* Дровер компетенции */}
      <CompetencyDrawer
        drawer={drawer}
        onClose={handleCloseDrawer}
        // Карта заявки не загружается — грейд неизвестен, не подписываем.
        grades={[]}
        // Без currentUser: карточка здесь справочная. С ним дровер считал бы целью
        // самого смотрящего и предлагал админу «Выдать» компетенцию себе, а не заявителю.
        userCompetencies={[]}
        competencyMapId="default"
        hideStatusAndActions={true}
      />
    </PageContainer>
  );
};
